import { makeStyles } from "@material-ui/core";

export const LessonCollectableCategoryStyles = makeStyles((theme) => ({
  item: {
    marginTop: 10,
    marginBottom: 10,
    "&:hover": {
      background: "#F1F5FF",
    },
    "&:hover $saveButton": {
      display: "block",
      background: "#235693",
    },
    "&:hover $lockIcon": {
      display: "none",
      background: "#235693",
    },
  },
  category: {
    display: "flex",
    flex: "1 auto",
    alignItems: "center",
  },
  categorySelected: {
    display: "flex",
    flex: "1",
    alignItems: "center",
    background: "#E7F9EE",
  },
  categoryIcon: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px",
    gap: "8px",
    minWidth: 56,
    minHeight: 56,
    color: "#FFFFFF",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(34),
    background: "#FFA740",
    borderRadius: 8,
    marginRight: "10px",

    "&.featured": {
      background: "#235693",
    },
  },
  categoryIconAll: {
    background: "#235693",
  },
  categoryName: {
    fontFamily: "Lato",
    fontStyle: "bold",
    fontSize: theme.typography.pxToRem(16),
    color: "#333333",
  },
  categoryActions: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginRight: 10,
  },
  categoryBackground: {
    background: "white",
  },
  categoryMouseOverBackground: {
    background: "#F1F5FF",
  },
  itemSavedInLabel: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    background: "#E7F9EE",
    color: "#0ABF52",
  },
  lockIcon: {
    display: "block",
  },
  saveButton: {
    display: "none",
  },
  tTruncate: {
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
  },
}));
